Ext.define('SA.view.TimeSeriesToolbar', {
    extend: 'SA.view.Toolbar',

    items: [
        {
            xtype: 'pvt-text',
            text: 'Time series for'
        }, {
            xtype: 'combo-button',
            itemId: 'attributeCombo',
            textTpl: '{name}, {year}',
            ui: 'underline',
            valueField: 'attribute'
        }, {
            xtype: 'combo-button',
            itemId: 'projectionsDropdown',
            margin: '0 0 0 10',
            textField: 'text',
            ui: 'underline',
            valueField: 'value',

            items: [
                {text: 'Including Projected Data', value: true},
                {text: 'Excluding Projected Data', value: false}
            ]
        }, {
            xtype: 'pvt-text',
            itemId: 'sortedByText',
            text: 'sorted by'
        }, {
            xtype: 'combo-button',
            emptyText: 'Data Variable',
            htmlEncode: false,
            itemId: 'sortDropdown',
            textTpl: '{.:locationRenderer}',
            valueField: 'id',
            ui: 'underline',

            menu: {
                defaults: {
                    encodeText: false
                }
            }
        }, {
            xtype: 'pvt-fill'
        }, {
            xtype: 'pvt-filtering-button',
            itemId: 'filteringButton',
            margin: '0 10 0 0'
        }, {
            xtype: 'pvt-view-actions-button',
            itemId: 'viewActionsButton',
            margin: '0 10 0 0'
        }, {
            xtype: 'pvt-export-button',
            margin: '0 10 0 0'
        }
    ],

    initComponent() {
        this.callParent();

        this.attributeCombo = this.down('#attributeCombo');
        this.projectionsDropdown = this.down('#projectionsDropdown');
        this.sortedByText = this.down('#sortedByText');
        this.sortDropdown = this.down('#sortDropdown');
        this.filteringButton = this.down('#filteringButton');
        this.viewActionsButton = this.down('#viewActionsButton');

        this.filteringButton.setMenuCfg(this.filteringMenuCfg);

        this.viewActionsButton
            .setProjectView(this.model)
            .addEditItem()
            .addGroup({text: 'Transpose Report', handler: () => this.onTransposeClick()})
            .addDeleteItem();
    },

    initEvents() {
        this.callParent();

        this.attributeCombo.on('change', this.onAttributeComboChange, this);
        this.projectionsDropdown.on('change', this.onProjectionsDropdownChange, this);
        this.sortDropdown.on('change', this.onSortDropdownChange, this);
    },

    onAttributeComboChange(combo, attribute) {
        this.fireEvent('change:attribute', attribute);
    },

    onProjectionsDropdownChange(dropdown, includeProjections) {
        this.fireEvent('change:projections', includeProjections);
    },

    onSortDropdownChange(dropdown, location) {
        this.fireEvent('change:sort', location);
    },

    onTransposeClick() {
        this.fireEvent('click:transpose');
    },

    setState(state) {
        var {attributeItems, attributeValue, canSort, includeProjections, sortItems, sortValue, filtered} = state;

        this.attributeCombo.setItemsAndValue(attributeItems, attributeValue);
        this.projectionsDropdown.setValue(includeProjections);
        this.sortedByText.setVisible(canSort);
        this.sortDropdown.setVisible(canSort);
        this.sortDropdown.setItemsAndValue(sortItems, sortValue);
        this.filteringButton.setIndicatorVisible(filtered);

        SA.ProjectViewToolbar.resizeDropDowns({force: true});
    }
});